const getters = {
    getSetoranKasWorkshopList: (state) => state.setoranKasWorkshopList,
    getSetoranKasWorkshopDetail: (state) => state.setoranKasWorkshopDetail,
    getPagination: (state) => state.pagination,
    getSearch: (state) => state.search,
    getIsSearch: (state) => state.isSearch,
    getQuerySetoranWorkshopList: (state) => state.querySetoranWorkshopList,
    getScrollPosition: (state) => state.scrollPosition,
};

export default getters;
